"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.styles = void 0;
// DatePickerStyles.ts
const css_in_js_1 = require("../../components/css-in-js");
exports.styles = {
    datePicker: (0, css_in_js_1.css) `
        position: relative;
        display: inline-block;
        cursor: default;
    `,
    trigger: (0, css_in_js_1.css) `
        display: flex;
        align-items: center;
        gap: 6px;
        padding: 6px 8px;
        border: 1px solid #ccc;
        line-height: 16px;
        border-radius: 4px;
        background: white;
        cursor: default;
        font-size: 24px;

        &:hover {
            border-color: #999;
        }

        &:disabled {
            opacity: 0.6;
            cursor: not-allowed;
        }
    `,
    icons: (0, css_in_js_1.css) `
        display: flex;
        align-items: center;
        // line-height: 24px;
    `,
    nativeInput: (0, css_in_js_1.css) `
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        width: 100%;
        height: 100%;
        padding: 0px;
        margin: 0px;
        border: 0px;
        border-radius: 4px;

        z-index: 1;
        opacity: 0;
        cursor: pointer;

        // Removes everything but the calendar icon
        left: 28px;
        width: 18px;

        /* WebKit (Chrome, Safari, Edge) */
        &::-webkit-calendar-picker-indicator {
            cursor: pointer;
        }

        /* Firefox */
        &::-moz-calendar-picker-indicator {
            cursor: pointer;
        }
    `,
};
//# sourceMappingURL=DatePickerStyles.js.map